<template>
  <div class="container">
    <div v-show="errorpreferences" class="notification is-danger">
      <h1 class="title is-4">
        ¡Antes de continuar debe configurar las preferencias!
      </h1>
      <h1 class="subtitle is-5">
        Este módulo necesita la congiguración de la cuenta de caja, de la forma
        en que imprimira los documentos y si requiere ver el cambio en la
        impresion de la factura.
      </h1>
      <router-link
        :to="{ name: 'settings.pventa' }"
        class="button is-danger is-outlined is-inverted is-medium"
        >Ir a Preferencias</router-link
      >
    </div>
    <y-viewencabezado
      :encabezado="encabezadoFactura"
      :fila="fila"
      :columna="columna"
      @fila="changeFila"
      @columna="changeColumna"
      :selection="selectionencabezado"
      :selcolumn="selcolumnencabezado"
    ></y-viewencabezado>
    <y-formencabezado
      v-if="fila === -1"
      :selection="selectionencabezado"
      :comundata="comundata"
      :columna="columna"
      :fila="fila"
      @fila="changeFila"
      :encabezado="encabezadoFactura"
      @columna="changeColumna"
      @changeInputEncabezado="changeDataEncabezado"
      @f10guardar="f10guardar"
    ></y-formencabezado>
    <div
      class="media1"
      v-for="(rg, index) in productosfactura"
      :key="index"
      v-bind:class="{ 'is-total': rg.esTotal }"
    >
      <y-viewregistrofrapvta
        :index="index"
        :fila="fila"
        :columna="columna"
        :reg="rg"
        :selection="selection"
        :selcolumn="selcolumn"
        @fila="changeFila"
        @columna="changeColumna"
      ></y-viewregistrofrapvta>
      <y-formregistrofrapvta
        v-if="showInput(index)"
        :index="index"
        :fila="fila"
        :reg="productosfactura"
        :columna="columna"
        :selection="selection"
        :selcolumn="selcolumn"
        :lengthReg="productosfactura.length"
        :comundata="comundata"
        @deleteReg="deleteReg"
        @validaReg="validaRegistro"
        @newReg="addReg"
        @fila="changeFila"
        @filatotal="changeFilatotal"
        @columna="changeColumna"
        @changeInputReg="changeData"
        @f10guardar="f10guardar"
      ></y-formregistrofrapvta>
    </div>
    <article class="media is-total">
      <div class="media-left">
        <div
          class="has-background-primary has-text-white has-text-centered numero"
        >
          T
        </div>
      </div>
      <div class="media-content">
        <div class="datospruducto">
          <table cellspacing="0" style="width: 100%">
            <tr>
              <td style="width: 15%">
                <strong>Total</strong>
              </td>
              <td style="width: 25%">
                <div style="float: left">
                  <span>Bruto</span>
                </div>
                <div style="float: right" class="fontMono has-text-right">
                  <span>{{ total.subtotal | number(2) }}</span>
                </div>
              </td>
              <td style="width: 5%"></td>
              <td style="width: 25%">
                <div style="float: left">
                  <span>Descuento:</span>
                </div>
                <div style="float: right" class="fontMono has-text-right">
                  <span>{{ total.descuento | number(2) }}</span>
                </div>
              </td>
              <td style="width: 5%"></td>
              <td style="width: 25%">
                <div style="float: left">Iva:</div>
                <div style="float: right" class="fontMono has-text-right">
                  {{ total.iva | number(2) }}
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="media-right fontMono has-text-right" style="width: 20%">
        <strong>{{ total.total | number(2) }}</strong>
      </div>
    </article>
    <div>
      <div class="field margin-top">
        <div class="control">
          <textarea
            v-model="textoFactura"
            class="textarea is-large"
            placeholder="Texto personalizado de la factura"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-6" style="margin-top: 3px">
        <div class="divtotal">
          <div class="texttotal">{{ contrapartida.nombre }}</div>
          <div class="numerototal fontMono has-text-right">
            {{ totalcontrapartida | number(2) }}
          </div>
        </div>
        <div v-for="(contrapartida, index) in totalesfactura" :key="index">
          <div class="divtotal hand" @click="selDatatotal(index)">
            <div class="texttotal">{{ contrapartida.nombre }}</div>
            <div class="numerototal fontMono has-text-right">
              <span :class="activetotal(index)">{{
                contrapartida.valor | number(2)
              }}</span>
            </div>
          </div>
          <y-formregistrototal
            v-if="showInputtotal(index)"
            @f10guardar="f10guardar"
            :lengthRegtotal="totalesfactura.length"
            :lengthReg="productosfactura.length"
            :filatotal="filatotal"
            :fila="fila"
            @fila="changeFila"
            @filatotal="changeFilatotal"
            @changeInputRegtotal="changeDatatotal"
            :reg="totalesfactura"
          ></y-formregistrototal>
        </div>
      </div>
      <div class="column is-6">
        <div class="margin-top buttons">
          <button
            class="button is-primary is-medium"
            id="botonGuardar"
            @click="f10guardar"
          >
            <span class="icon is-medium">
              <i class="material-icons">save</i> </span
            >&nbsp; Guardar F10
          </button>
          <button
            class="button is-light is-medium"
            v-show="!turno._id"
            @click="saveandprint"
          >
            <span class="icon is-medium">
              <i class="material-icons">print</i> </span
            >&nbsp; Guardar e Imprimir
          </button>
          <button class="button is-warning is-medium" @click="cancelar">
            <span class="icon is-medium">
              <i class="material-icons">cancel</i> </span
            >&nbsp; Cancelar
          </button>
        </div>
      </div>
    </div>
    <y-modalcashback
      :show="showmodalcash"
      :datamodalcashback="datamodalcashback"
      @showmodalcashback="showmodalcashback"
      @responsemodalcashback="responsemodalcashback"
    ></y-modalcashback>
    <div v-show="false">
      <y-printfrapvta
        v-if="
          dataprint.registros[0].valor &&
          dataprint.comprobante.estructura === 'factura' &&
          encabezadoFactura.preferences.impresora === '0'
        "
        id="printfra"
        :dataprint="dataprint"
      ></y-printfrapvta>
      <y-printfrapvtastrip
        v-if="
          dataprint.registros[0].valor &&
          dataprint.comprobante.estructura === 'factura' &&
          encabezadoFactura.preferences.impresora === '1'
        "
        id="printfra"
        :dataprint="dataprint"
      ></y-printfrapvtastrip>
      <y-printfrapvtastrip80
        v-if="
          dataprint.registros[0].valor &&
          dataprint.comprobante.estructura === 'factura' &&
          encabezadoFactura.preferences.impresora === '2'
        "
        id="printfra"
        :dataprint="dataprint"
      ></y-printfrapvtastrip80>
    </div>
  </div>
</template>
<script>
import yViewencabezado from "@/components/registrar/Viewencabezado.vue";
import yFormencabezado from "@/components/registrar/Formencabezado.vue";
import yFormregistrofrapvta from "@/components/registrar/Formregistrofrapvta.vue";
import yViewregistrofrapvta from "@/components/registrar/Viewregistrofrapvta.vue";
import yFormregistrototal from "@/components/registrar/Formregistrototal.vue";
import yModalcashback from "@/components/modals/Modalcashback.vue";
import apiServices from "@/services/yungol-services";
import functions from "@/helpers/functions";
import yPrintfrapvta from "@/components/prints/Frapvta.vue";
import yPrintfrapvtastrip from "@/components/prints/Frapvtastrip.vue";
import yPrintfrapvtastrip80 from "@/components/prints/Frapvtastrip80.vue";
import { mapState } from "vuex";

function getSum1(t, k, v, arr) {
  t.subtotal = parseInt(t.subtotal) + parseInt(k.valor);
  t.iva = parseInt(t.iva) + parseInt((k.valor * k.datosFactura.impuesto) / 100);
  t.total =
    parseInt(t.total) +
    parseInt(k.valor) +
    parseInt((k.valor * k.datosFactura.impuesto) / 100);
  return t;
}

function sumarDias(fecha, dias) {
  fecha.setDate(fecha.getDate() + dias);
  return fecha;
}

export default {
  props: {
    comundata: {
      type: Object,
    },
    borrador: Object,
    turno: Object,
  },
  computed: {
    ...mapState([
      "empresa",
      "cuentas",
      "nits",
      "productos",
      "bodegas",
      "vendedores",
      "user",
    ]),
    listas() {
      const _this = this;
      const returned = [];
      const keyslistas = Object.keys(this.empresa.modulos.pventa.listas);
      keyslistas.forEach((e) => {
        returned.push({
          codigo: String(e),
          nombre: _this.empresa.modulos.pventa.listas[e],
        });
      });
      return returned;
    },
    total() {
      const _this = this;
      const total = this.productosfactura.reduce(
        function (acumulator, current) {
          const cantidad = _this.convertvalor(current.cantidad);
          const vlrUnitario = _this.convertvalor(current.vlrUnitario);
          const porcentajedescuento = _this.convertvalor(current.descuento);
          const subtotal = cantidad * vlrUnitario;
          const descuento = (subtotal * porcentajedescuento) / 100;
          const bruto = subtotal - descuento;
          const porcentajeiva = current.objetoProducto
            ? _this.convertvalor(current.objetoProducto.linea.vImpuesto)
            : 0;
          const iva = (bruto * porcentajeiva) / 100;
          acumulator.total += subtotal - descuento + iva;
          acumulator.iva += iva;
          acumulator.descuento += descuento;
          acumulator.subtotal += subtotal;
          return acumulator;
        },
        {
          subtotal: 0,
          total: 0,
          iva: 0,
          descuento: 0,
        }
      );
      return total;
    },
    totalcontrapartida() {
      const totalotroscontrapartida = this.totalesfactura.reduce(
        (acumulator, current) => {
          return acumulator + current.valor;
        },
        0
      );
      return this.total.total - totalotroscontrapartida;
    },
  },
  data() {
    return {
      textoFactura: "",
      dataprint: {
        totales: {
          subtotal: 0,
          iva: 0,
          total: 0,
        },
        empresa: {
          nit: "",
          nombrec: "",
          nombre: "",
          ciudad: "",
          direccion: "",
          telefono: "",
        },
        vencimiento: "2020-07-30T05:00:00.000Z",
        incluircambio: false,
        comprobante: {
          t1: "",
          t2: "",
          titulo: "",
          nombre: "",
          prefijo: "",
          caracteres: "",
          factura: {
            resolucion: "",
            piefactura: "",
            negrita: "",
            mensajefinal: "",
          },
        },
        contrapartidas: [
          {
            nombrepers: "",
          },
        ],
        contrapartida: {
          valor: 0,
          idcuenta: {
            nombre: "",
          },
        },
        registros: [
          {
            documento: 0,
            cantidad: 0,
            descuento: 0,
            vlrUnitario: 0,
            valor: 0,
            fecha: "2020-07-30T05:00:00.000Z",
            producto: {
              codigo: "",
              descripcion: "",
            },
            datosFactura: {
              texto: "",
              impuesto: 0,
              cambio: 0,
            },
            idnit: {
              nombre: "",
              codigo: "",
              direccion: "",
              ciudad: "",
              telefono: "",
              correo: "",
              fecha: "2020-07-30T05:00:00.000Z",
            },
          },
        ],
      },
      showmodalcash: false,
      datamodalcashback: {
        name: "Contrapartida",
        valor: 0,
      },
      userpreferences: null,
      errorpreferences: null,
      encabezadoFactura: {
        idnit: "",
        nit: "",
        nombreNit: "",
        bodega: "",
        nbodega: "",
        nvendedor: "",
        nccostos: "",
        ccostos: "",
        nombrebodega: "",
        nombrevendedor: "",
        nombreCcostos: "",
        nlprecios: "",
        fpago: "",
        nombrelprecios: "",
        nombrefpago: "",
        cumpleCcosto: true,
        cumpleNit: true,
        cumpleVendedor: true,
        cumpleBodega: true,
        cumpleLprecios: true,
        cumpleFpago: true,
        preferences: {
          cuenta: "",
          impresora: "0",
          incluircambio: "0",
        },
        vencimientos: [
          {
            codigo: 0,
            nombre: "Contado",
          },
          {
            codigo: 7,
            nombre: "7 Días",
          },
          {
            codigo: 15,
            nombre: "15 Días",
          },
          {
            codigo: 30,
            nombre: "30 Días",
          },
          {
            codigo: 45,
            nombre: "45 Días",
          },
          {
            codigo: 60,
            nombre: "60 Días",
          },
          {
            codigo: 90,
            nombre: "90 Días",
          },
        ],
      },
      contrapartida: {},
      productosfactura: [],
      totalesfactura: [],
      registros: [],
      columna: 1,
      inputReg: "",
      fila: -1,
      filatotal: 0,
      selcolumnencabezado: {
        columnnit: 1,
        columnvendedor: 2,
        columnfpago: 3,
        columnbodega: 4,
        columnlprecio: 5,
        columnccosto: 6,
      },
      selcolumn: {
        columnProducto: 1,
        columnCantidad: 2,
        columnVlrunitario: 3,
        columnDescuento: 4,
      },
      selectionencabezado: [
        {
          cod: "nit",
          nombre: "Cliente",
          bd: "idnit",
          tiene: "tNit",
          valida: "cumpleNit",
          texto: "nombreNit",
        },
        {
          cod: "nvendedor",
          nombre: "Vendedor",
          bd: "vendedor",
          tiene: "tVendedor",
          valida: "cumpleVendedor",
          texto: "nombrevendedor",
        },
        {
          cod: "fpago",
          nombre: "Forma de pago",
          bd: "fpago",
          tiene: "tfpago",
          valida: "cumpleFpago",
          texto: "nombrefpago",
        },
        {
          cod: "nbodega",
          nombre: "Bodega",
          bd: "bodega",
          tiene: "tBodega",
          valida: "cumpleBodega",
          texto: "nombrebodega",
        },
        {
          cod: "lprecios",
          nombre: "Lista Precios",
          bd: "lprecios",
          tiene: "tlprecios",
          valida: "cumpleLprecios",
          texto: "nombrelprecios",
        },
        {
          cod: "nccostos",
          nombre: "C Costos",
          bd: "ccostos",
          tiene: "tCcosto",
          valida: "cumpleCcosto",
          texto: "nombreCcostos",
        },
      ],
      selection: [
        // la idea de seleccion es tener configurado cada boton que aparece en el formulario cod es como esta en el registro, nombre es como aparece el boton bd es como se guarda en la base de datos tiene es si la cuenta exige ese campo valida es si esta validado el campo, texto donde esta el texto ya sea de la cuenta o del nit referencia etc
        {
          cod: "nproducto",
          nombre: "Producto",
          bd: "producto",
          tiene: "tProducto",
          valida: "cumpleProducto",
          texto: "nombreproducto",
        },
        {
          cod: "cantidad",
          nombre: "Cantidad",
          bd: "cantidad",
          tiene: "tCantidad",
          valida: "cumpleCantidad",
          texto: "cantidad",
        },
        {
          cod: "vlrUnitario",
          nombre: "Vlr Unitario",
          bd: "vlrUnitario",
          tiene: "tPreciounitario",
          valida: "cumplePreciounitario",
          texto: "vlrUnitario",
        },
        {
          cod: "descuento",
          nombre: "Descuento",
          bd: "descuento",
          tiene: "tDescuento",
          valida: "cumpleDescuento",
          texto: "descuento",
        },
      ],
    };
  },
  methods: {
    async saveandprint() {
      try {
        const _this = this;
        this.converttoregistros();
        const result = await this.saveRecors(_this.registros);
        this.dataprint = await this.transformdatatoprint(result.data);
        setTimeout(function () {
          _this.$print("printfra", {
            name: `${_this.dataprint.comprobante.nombre} - ${_this.dataprint.registros[0].documento} - ${_this.dataprint.registros[0].mes}`,
          });
          _this.$emit("notifyguardado", { guardo: true });
        }, 100);
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema guardando los registros.",
          type: "is-danger",
          position: "top-center",
        });
        console.log(err);
      }
    },
    cancelar() {
      console.log("estoy cancelando");
      this.$emit("cancelar");
    },
    saveRecors(registros) {
      return new Promise(async function (resolve, reject) {
        try {
          const result = await apiServices.post(`/registroslote`, registros);
          return resolve(result);
        } catch (err) {
          return reject(err);
        }
      });
    },
    transformdatatoprint(registros) {
      const _this = this;
      return new Promise(function (resolve, reject) {
        try {
          const dataprint = {};
          dataprint.empresa = _this.empresa;
          dataprint.comprobante = _this.comundata.comprobante;
          dataprint.registros = [];
          dataprint.contrapartida = {};
          dataprint.contrapartidas = [];
          dataprint.incluircambio =
            _this.encabezadoFactura.preferences.incluircambio;
          registros.forEach(function (k, v) {
            if (k.idcuenta.ingreso) {
              dataprint.registros.push(k);
            } else {
              if (dataprint.comprobante.cuenta === k.idcuenta._id) {
                dataprint.contrapartida = k;
              } else {
                if (dataprint.comprobante.factura.contrapartidas) {
                  dataprint.comprobante.factura.contrapartidas.forEach(
                    function (k2, v2) {
                      if (k2._id === k.idcuenta._id) {
                        k.nombrepers = k2.nombre;
                        dataprint.contrapartidas.push(k);
                      }
                    }
                  );
                }
              }
            }
          });
          dataprint.totales = dataprint.registros.reduce(getSum1, {
            subtotal: 0,
            iva: 0,
            total: 0,
          });
          var d = new Date(dataprint.registros[0].fecha);
          var d1 = parseInt(dataprint.registros[0].datosFactura.fpago);
          dataprint.vencimiento = sumarDias(d, d1);
          resolve(dataprint);
        } catch (err) {
          reject(err);
        }
      });
    },
    async responsemodalcashback(cashback) {
      try {
        const _this = this;
        if (cashback.status === "print") {
          for (let index in _this.registros) {
            const record = _this.registros[index];
            if (record.grupo === "4") {
              _this.registros[index].datosFactura.cambio = cashback.cashback;
              _this.registros[index].datosFactura.efectivo = cashback.cash;
            }
          }
          this.showmodalcashback();
          const result = await this.saveRecors(_this.registros);
          this.dataprint = await this.transformdatatoprint(result.data);
          setTimeout(function () {
            _this.$print("printfra", {
              name: `${_this.dataprint.comprobante.nombre} - ${_this.dataprint.registros[0].documento} - ${_this.dataprint.registros[0].mes}`,
            });
            _this.$emit("notifyguardado", { guardo: true });
          }, 100);
        } else if (cashback.status === "save") {
          for (let index in _this.registros) {
            const record = _this.registros[index];
            if (record.grupo === "4") {
              _this.registros[index].datosFactura.cambio = cashback.cashback;
              _this.registros[index].datosFactura.efectivo = cashback.cash;
            }
          }
          this.showmodalcashback();
          await this.saveRecors(_this.registros);
          _this.$emit("notifyguardado", { guardo: true });
        }
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema guardando los registros.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema guardando los registros", err);
      }
    },
    showmodalcashback() {
      this.showmodalcash = !this.showmodalcash;
    },
    async guardaRegistros() {
      const _this = this;
      let result;
      try {
        if (this.turno._id) {
          this.datamodalcashback = {
            name: this.contrapartida.nombre,
            valor: this.totalcontrapartida,
          };
          this.showmodalcashback();
        } else {
          result = await this.saveRecors(_this.registros);
          if (result.data) {
            this.registros = [];
            this.productosfactura = [];
            _this.$emit("notifyguardado", { guardo: true });
            this.$store.dispatch("notify", {
              message: "Registro guardado con éxito.",
              type: "is-primary",
              position: "top-center",
            });
          }
        }
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema guardando los registros.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema guardando los registros", err);
      }
    },
    createregistros(producto, orden) {
      const _this = this;
      _this.createreg(producto, "ingreso", orden);
      if (producto.objetoProducto.linea.impuesto) {
        _this.createreg(producto, "impuesto");
      }
      if (producto.objetoProducto.linea.inventario) {
        _this.createreg(producto, "inventario");
        _this.createreg(producto, "costo");
      }
    },
    converttoregistros() {
      this.registros = [];
      const _this = this;
      for (let i = 0; i < this.productosfactura.length; i++) {
        this.validaRenglon(i);
        if (
          _this.productosfactura[i].cumpleTodo &&
          _this.convertvalor(_this.productosfactura[i].cantidad) > 0 &&
          _this.convertvalor(_this.productosfactura[i].vlrUnitario) > 0
        ) {
          _this.createregistros(_this.productosfactura[i], i);
        }
      }
      _this.createreg(_this.contrapartida, "contrapartida");
      if (_this.totalesfactura.length > 0) {
        for (let i = 0; i < _this.totalesfactura.length; i++) {
          _this.createreg(_this.totalesfactura[i], "total");
        }
      }
    },
    selDatatotal(filatotal) {
      this.fila = -2;
      this.filatotal = filatotal;
    },
    activetotal(f) {
      if (this.fila === -2 && f === this.filatotal) {
        return {
          totalselected: true,
        };
      }
    },
    convertvalor(text) {
      let number = parseFloat(text);
      if (isNaN(number)) {
        number = 0;
      }
      return number;
    },
    f10guardar() {
      this.converttoregistros();
      this.guardaRegistros();
    },
    changeDatatotal(payload) {
      console.log("ejecuta el change data", payload);
      this.totalesfactura[payload.filatotal].valor = this.convertvalor(
        payload.data
      );
    },
    changeData(payload) {
      // si esta en la columna total no puede editar la cuenta ni el valor
      this.productosfactura[payload.fila][
        this.selection[payload.columna - 1].cod
      ] = payload.data;
      if (this.columna === this.selcolumn.columnValor) {
        const temporal = this.calculaTotal(this.fila);
        this.productosfactura[this.registros.length - 1].valor = temporal;
      }
    },
    addReg() {
      this.createregproducto(this);
    },
    validaRegistro() {
      this.validaRenglon(this.fila);
    },
    deleteReg(payload) {
      this.productosfactura.splice(payload, 1);
      this.fila = payload - 1;
    },
    showInput(f) {
      if (this.fila === f) {
        return true;
      } else {
        return false;
      }
    },
    showInputtotal(f) {
      if (this.fila === -2) {
        if (this.filatotal === f) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    changeFila(n) {
      this.fila = n;
    },
    changeFilatotal(n) {
      this.filatotal = n;
    },
    validaencabezado(fila, colValidar, _this) {
      let data = null;
      if (colValidar === this.selcolumnencabezado.columnnit) {
        data = functions.findData(
          _this.nits,
          _this.encabezadoFactura.nit,
          "codigo"
        );
      } else if (colValidar === this.selcolumnencabezado.columnvendedor) {
        data = functions.findData(
          _this.vendedores,
          _this.encabezadoFactura.nvendedor,
          "codigo"
        );
        if (!data) {
          data = {
            nombre: null,
            _id: null,
          };
        }
      } else if (colValidar === this.selcolumnencabezado.columnbodega) {
        data = functions.findData(
          _this.bodegas,
          _this.encabezadoFactura.nbodega,
          "codigo"
        );
        if (data) {
          data.nombre = data.descripcion;
        }
      } else if (colValidar === this.selcolumnencabezado.columnlprecio) {
        data = functions.findData(
          _this.listas,
          String(_this.encabezadoFactura.lprecios),
          "codigo"
        );
        if (data) {
          data._id = data.codigo;
        }
      } else if (colValidar === this.selcolumnencabezado.columnccosto) {
        data = functions.findData(
          _this.comundata.ccostos,
          _this.encabezadoFactura.nccostos,
          "codigo"
        );
      } else if (colValidar === this.selcolumnencabezado.columnfpago) {
        data = functions.findData(
          _this.encabezadoFactura.vencimientos,
          parseInt(_this.encabezadoFactura.fpago),
          "codigo"
        );
        if (data) {
          data._id = data.codigo;
        }
      }
      if (data) {
        _this.encabezadoFactura[
          _this.selectionencabezado[colValidar - 1].texto
        ] = data.nombre;
        _this.encabezadoFactura[_this.selectionencabezado[colValidar - 1].bd] =
          data._id;
        _this.encabezadoFactura[
          _this.selectionencabezado[colValidar - 1].valida
        ] = true;
      } else {
        _this.encabezadoFactura[
          _this.selectionencabezado[colValidar - 1].texto
        ] = null;
        _this.encabezadoFactura[
          _this.selectionencabezado[colValidar - 1].bd
        ] = null;
        _this.encabezadoFactura[
          _this.selectionencabezado[colValidar - 1].valida
        ] = false;
      }
    },
    validaproducto() {
      const _this = this;
      let data = null;
      data = functions.findData(
        _this.productos,
        _this.productosfactura[_this.fila].nproducto,
        "codigo"
      );
      if (data) {
        _this.productosfactura[_this.fila].objetoProducto = data;
        _this.productosfactura[_this.fila].nombreproducto = data.descripcion;
        _this.productosfactura[_this.fila].producto = data._id;
        let lprecio = parseInt(this.encabezadoFactura.lprecios);
        if (isNaN(lprecio)) {
          lprecio = 0;
        }
        _this.productosfactura[_this.fila].vlrUnitario = parseFloat(
          data.precios[lprecio]
        );
        _this.productosfactura[_this.fila].cumpleProducto = true;
      } else {
        _this.productosfactura[_this.fila].cumpleProducto = false;
      }
    },
    validacantidad() {
      const _this = this;
      const cantidad = parseFloat(_this.productosfactura[_this.fila].cantidad);
      if (cantidad === 0) {
        _this.productosfactura[_this.fila].cumpleCantidad = false;
      } else if (isNaN(cantidad)) {
        _this.productosfactura[_this.fila].cumpleCantidad = false;
      } else {
        _this.productosfactura[_this.fila].cumpleCantidad = true;
      }
    },
    validapreciounitario() {
      const _this = this;
      const punitario = parseFloat(
        _this.productosfactura[_this.fila].vlrUnitario
      );
      if (punitario === 0) {
        _this.productosfactura[_this.fila].cumplePreciounitario = false;
      } else if (isNaN(punitario)) {
        _this.productosfactura[_this.fila].cumplePreciounitario = false;
      } else {
        _this.productosfactura[_this.fila].cumplePreciounitario = true;
      }
    },
    validadescuento() {
      const _this = this;
      const descuento = parseFloat(
        _this.productosfactura[_this.fila].descuento
      );
      if (descuento === 0) {
        _this.productosfactura[_this.fila].cumpleDescuento = true;
      } else if (isNaN(descuento)) {
        _this.productosfactura[_this.fila].cumpleDescuento = false;
      } else {
        _this.productosfactura[_this.fila].cumpleDescuento = true;
      }
    },
    validaRenglon(fila) {
      const _this = this;
      if (
        _this.productosfactura[fila].cumpleProducto &&
        _this.productosfactura[fila].cumpleCantidad &&
        _this.productosfactura[fila].cumplePreciounitario &&
        _this.productosfactura[fila].cumpleDescuento
      ) {
        _this.productosfactura[fila].cumpleTodo = true;
      } else {
        _this.productosfactura[fila].cumpleTodo = false;
      }
    },
    changeDataEncabezado(payload) {
      if (this.fila === -1) {
        // si la fila es -1 es porque esta en el encabezado
        this.encabezadoFactura[
          this.selectionencabezado[payload.columna - 1].cod
        ] = payload.data;
      }
    },
    dataDefault() {
      const _this = this;
      // carga los datos por default de la factura
      this.encabezadoFactura.idnit = this.comundata.comprobante.factura.nit._id;
      this.encabezadoFactura.nit = this.comundata.comprobante.factura.nit.codigo;
      this.encabezadoFactura.nombreNit = this.comundata.comprobante.factura.nit.nombre;
      this.encabezadoFactura.bodega = this.comundata.comprobante.factura.bodega._id;
      this.encabezadoFactura.nbodega = this.comundata.comprobante.factura.bodega.codigo;
      this.encabezadoFactura.nombrebodega = this.comundata.comprobante.factura.bodega.descripcion;
      this.encabezadoFactura.lprecios = this.comundata.comprobante.factura.lprecios.codigo;
      this.encabezadoFactura.nombrelprecios = this.comundata.comprobante.factura.lprecios.nombre;
      this.encabezadoFactura.nombreCcostos = this.comundata.comprobante.factura.ccostos.nombre;
      this.encabezadoFactura.nccostos = this.comundata.comprobante.factura.ccostos.codigo;
      this.encabezadoFactura.ccostos = this.comundata.comprobante.factura.ccostos._id;
      this.encabezadoFactura.fpago = this.comundata.comprobante.vencimiento;
      const nombrefpago = this.encabezadoFactura.vencimientos.filter(
        (vencimiento) =>
          vencimiento.codigo === parseInt(_this.encabezadoFactura.fpago)
      );
      this.encabezadoFactura.nombrefpago = nombrefpago[0].nombre;
      const contrapartida = this.cuentas.filter(
        (cuenta) => cuenta._id === _this.comundata.comprobante.cuenta
      );
      this.contrapartida = contrapartida[0];
      if (this.comundata.comprobante.factura.contrapartidas) {
        this.comundata.comprobante.factura.contrapartidas.forEach(
          (contrapartida) => {
            const data = {
              _id: contrapartida._id,
              codigo: contrapartida.codigo,
              nombre: contrapartida.nombre,
              dctoref: contrapartida.dctoref,
              base: contrapartida.base,
              ccosto: contrapartida.ccosto,
              tercero: contrapartida.tercero,
              valor: 0,
            };
            _this.totalesfactura.push(data);
          }
        );
      }

      // this.encabezadoFactura.nlprecios = this.comundata.comprobante.factura.bodega.descripcion;
    },
    changeColumna(n) {
      this.columna = n;
    },
    createreg(producto, estructura, orden) {
      const _this = this;
      const d = {
        idcuenta: null,
        idnit: null,
        descripcion: null,
        fecha: null,
        documento: null, // aqui va el numero de documento que tiene la comundata
        comprobanteid: null, // aqui va el id del comprobante que lo tiene la coumndata
        docRef: null,
        ccostos: null,
        base: 0,
        tipo: null, // 1 para el debito y 2 para el credito
        valor: 0,
        year: null, // aqui va el año que viene de comundata
        mes: null, // aqui va el mes que viene de commundata
        datosFactura: false, // este es para la factura
        turno: null, // este es para el id del turno en el caso que sea de un cuadre de caja
        tipor: null, // este es tipo de registro ingreso inventario costo o impuesto y solo aplica para punto de venta
        producto: null, // este es el id del producto para productos de punto de venta
        grupop: null, // este es el id del grupo del producto
        pventa: true, // este se pone true si es de punto de venta
        bodega: null, // este es el id de la bodega
        cantidad: 0, // numero de cantidades
        vlrUnitario: 0, // numero del valor unitario
        esTotal: false, // true o false para saber si es el total del documento
        descuento: null, // descuento este dato solo lo tiene las cuentas de ventas de la factura
        orden: null,
        // hasta aca es la estructura de la base de datos
        cuenta: null,
        cuentadetalle: null,
        nombreCuenta: null,
        nit: null,
        nombreNit: null,
        nombreCcostos: null,
        idCcostos: null,
        pptal: null,
        idpptal: null,
        nombrebodega: null,
        nbodega: null,
        nombreproducto: null,
        nproducto: null,
        productodetalle: null,
        porcentaje: null, // aqui va el porcentaje de retefuente
        tipo1: "+",
        tCuenta: true,
        tNit: false,
        tDescripcion: true,
        tCcosto: false,
        tBase: false,
        tDocref: false,
        tProducto: true,
        tCantidad: true,
        tDescuento: true,
        tPreciounitario: true,
        tBodega: false,
        tTipo: true,
        tValor: true,
        cumpleCuenta: true,
        cumpleNit: true,
        cumpleDescripcion: true,
        cumpleRef: true,
        cumpleCcosto: true,
        cumpleBase: true,
        cumpleProducto: true,
        cumpleCantidad: true,
        cumplePreciounitario: true,
        cumpleBodega: true,
        cumpleValor: true,
        cumpleTipo1: true,
        cumpleTodo: false,
      };
      if (this.empresa.modulos.cuadrecaja) {
        d.turno = this.turno._id;
      }
      if (estructura === "ingreso") {
        d.orden = orden;
        d.idcuenta = producto.objetoProducto.linea.ctaIngreso;
        d.idnit = _this.encabezadoFactura.idnit;
        d.descripcion = `Venta de ${producto.cantidad} ${producto.objetoProducto.unidad.codigo} de ${producto.nombreproducto} - documento ${_this.comundata.numDoc}`;
        d.fecha = new Date(
          functions.year(_this.comundata.periodo),
          functions.mes(_this.comundata.periodo) - 1,
          _this.comundata.dia
        );
        d.documento = _this.comundata.numDoc;
        d.comprobanteid = _this.comundata.comprobante._id;
        d.docRef = "0";
        d.ccostos = _this.encabezadoFactura.nccostos;
        d.idCcostos = _this.encabezadoFactura.ccostos;
        d.tipo = _this.comundata.comprobante.tipo === 1 ? 2 : 1;
        d.valor =
          _this.convertvalor(producto.cantidad) *
            _this.convertvalor(producto.vlrUnitario) -
          (_this.convertvalor(producto.cantidad) *
            _this.convertvalor(producto.vlrUnitario) *
            _this.convertvalor(producto.descuento)) /
            100;
        d.year = functions.year(_this.comundata.periodo);
        d.mes = functions.mes(_this.comundata.periodo);
        d.tipor = "ingreso";
        d.producto = producto.objetoProducto._id;
        d.grupop = producto.objetoProducto.grupo._id;
        d.pventa = true;
        d.bodega = _this.encabezadoFactura.bodega;
        d.cantidad = _this.convertvalor(producto.cantidad);
        d.vlrUnitario = _this.convertvalor(producto.vlrUnitario);
        d.esTotal = false;
        d.descuento = _this.convertvalor(producto.descuento);
        const cuentaingreso = _this.cuentas.filter(
          (cuenta) => cuenta._id === producto.objetoProducto.linea.ctaIngreso
        );
        d.grupo = functions.grupo(cuentaingreso[0].codigo);
        d.sgrupo = functions.sgrupo(cuentaingreso[0].codigo);
        d.scuenta = functions.scuenta(cuentaingreso[0].codigo);
        d.datosFactura = {
          efectivo: 0,
          cambio: 0,
          impuesto: _this.convertvalor(producto.objetoProducto.linea.vImpuesto),
          fpago: _this.convertvalor(_this.encabezadoFactura.fpago),
          texto: _this.textoFactura
        };
        d.cumpleTodo = true;
      }
      if (estructura === "impuesto") {
        d.idcuenta = producto.objetoProducto.linea.ctaImpto;
        d.idnit = _this.encabezadoFactura.idnit;
        d.descripcion = `Venta de ${producto.cantidad} ${producto.objetoProducto.unidad.codigo} de ${producto.nombreproducto} - documento ${_this.comundata.numDoc}`;
        d.fecha = new Date(
          functions.year(_this.comundata.periodo),
          functions.mes(_this.comundata.periodo) - 1,
          _this.comundata.dia
        );
        d.documento = _this.comundata.numDoc;
        d.comprobanteid = _this.comundata.comprobante._id;
        d.docRef = "0";
        d.ccostos = _this.encabezadoFactura.nccostos;
        d.idCcostos = _this.encabezadoFactura.ccostos;
        d.tipo = _this.comundata.comprobante.tipo === 1 ? 2 : 1;
        const valor =
          _this.convertvalor(producto.cantidad) *
            _this.convertvalor(producto.vlrUnitario) -
          (_this.convertvalor(producto.cantidad) *
            _this.convertvalor(producto.vlrUnitario) *
            _this.convertvalor(producto.descuento)) /
            100;
        d.base = valor;
        d.valor =
          (valor *
            _this.convertvalor(producto.objetoProducto.linea.vImpuesto)) /
          100;
        d.year = functions.year(_this.comundata.periodo);
        d.mes = functions.mes(_this.comundata.periodo);
        d.tipor = "impuesto";
        d.pventa = true;
        d.esTotal = false;
        const cuentaimpuesto = _this.cuentas.filter(
          (cuenta) => cuenta._id === d.idcuenta
        );
        d.grupo = functions.grupo(cuentaimpuesto[0].codigo);
        d.sgrupo = functions.sgrupo(cuentaimpuesto[0].codigo);
        d.scuenta = functions.scuenta(cuentaimpuesto[0].codigo);
        d.datosFactura = {
          fpago: 0,
          texto: _this.textoFactura
        };
        d.cumpleTodo = true;
      }
      if (estructura === "inventario") {
        d.idcuenta = producto.objetoProducto.linea.ctaInventario;
        d.idnit = _this.encabezadoFactura.idnit;
        d.descripcion = `Venta de ${producto.cantidad} ${producto.objetoProducto.unidad.codigo} de ${producto.nombreproducto} - documento ${_this.comundata.numDoc}`;
        d.fecha = new Date(
          functions.year(_this.comundata.periodo),
          functions.mes(_this.comundata.periodo) - 1,
          _this.comundata.dia
        );
        d.documento = _this.comundata.numDoc;
        d.comprobanteid = _this.comundata.comprobante._id;
        d.docRef = "0";
        d.ccostos = "0";
        d.tipo = _this.comundata.comprobante.tipo === 1 ? 2 : 1;
        if (
          producto.objetoProducto.datosProducto &&
          producto.objetoProducto.datosProducto[_this.encabezadoFactura.bodega]
        ) {
          d.valor =
            producto.objetoProducto.datosProducto[
              _this.encabezadoFactura.bodega
            ].ultimoCalculo.costo * _this.convertvalor(producto.cantidad);
          d.vlrUnitario =
            producto.objetoProducto.datosProducto[
              _this.encabezadoFactura.bodega
            ].ultimoCalculo.costo;
        } else {
          d.valor = 0;
          d.vlrUnitario = 0;
        }
        d.year = functions.year(_this.comundata.periodo);
        d.mes = functions.mes(_this.comundata.periodo);
        d.tipor = "inventario";
        d.producto = producto.objetoProducto._id;
        d.grupop = producto.objetoProducto.grupo._id;
        d.pventa = true;
        d.bodega = _this.encabezadoFactura.bodega;
        d.cantidad = _this.convertvalor(producto.cantidad);
        d.esTotal = false;
        const cuentainventario = _this.cuentas.filter(
          (cuenta) => cuenta._id === d.idcuenta
        );
        d.grupo = functions.grupo(cuentainventario[0].codigo);
        d.sgrupo = functions.sgrupo(cuentainventario[0].codigo);
        d.scuenta = functions.scuenta(cuentainventario[0].codigo);
        d.datosFactura = {
          fpago: _this.convertvalor(_this.encabezadoFactura.fpago),
          texto: _this.textoFactura
        };
        d.cumpleTodo = true;
      }
      if (estructura === "costo") {
        d.idcuenta = producto.objetoProducto.linea.ctaCosto;
        d.idnit = _this.encabezadoFactura.idnit;
        d.descripcion = `Venta de ${producto.cantidad} ${producto.objetoProducto.unidad.codigo} de ${producto.nombreproducto} - documento ${_this.comundata.numDoc}`;
        d.fecha = new Date(
          functions.year(_this.comundata.periodo),
          functions.mes(_this.comundata.periodo) - 1,
          _this.comundata.dia
        );
        d.documento = _this.comundata.numDoc;
        d.comprobanteid = _this.comundata.comprobante._id;
        d.docRef = "0";
        d.ccostos = "0";
        d.tipo = _this.comundata.comprobante.tipo === 1 ? 1 : 2;
        if (
          producto.objetoProducto.datosProducto &&
          producto.objetoProducto.datosProducto[_this.encabezadoFactura.bodega]
        ) {
          d.valor =
            producto.objetoProducto.datosProducto[
              _this.encabezadoFactura.bodega
            ].ultimoCalculo.costo * _this.convertvalor(producto.cantidad);
          d.vlrUnitario =
            producto.objetoProducto.datosProducto[
              _this.encabezadoFactura.bodega
            ].ultimoCalculo.costo;
        } else {
          d.valor = 0;
          d.vlrUnitario = 0;
        }
        d.year = functions.year(_this.comundata.periodo);
        d.mes = functions.mes(_this.comundata.periodo);
        d.tipor = "costo";
        d.producto = producto.objetoProducto._id;
        d.grupop = producto.objetoProducto.grupo._id;
        d.pventa = true;
        d.bodega = _this.encabezadoFactura.bodega;
        d.cantidad = _this.convertvalor(producto.cantidad);
        d.esTotal = false;
        const cuentacosto = _this.cuentas.filter(
          (cuenta) => cuenta._id === d.idcuenta
        );
        d.grupo = functions.grupo(cuentacosto[0].codigo);
        d.sgrupo = functions.sgrupo(cuentacosto[0].codigo);
        d.scuenta = functions.scuenta(cuentacosto[0].codigo);
        d.datosFactura = {
          fpago: _this.convertvalor(_this.encabezadoFactura.fpago),
          texto: _this.textoFactura
        };
        d.cumpleTodo = true;
      }
      if (estructura === "contrapartida") {
        d.idcuenta = producto._id;
        d.idnit = producto.tercero
          ? _this.encabezadoFactura.idnit
          : _this.empresa.nit0;
        d.descripcion = `Factura ${_this.comundata.numDoc} - ${_this.encabezadoFactura.nombreNit}`;
        d.fecha = new Date(
          functions.year(_this.comundata.periodo),
          functions.mes(_this.comundata.periodo) - 1,
          _this.comundata.dia
        );
        d.documento = _this.comundata.numDoc;
        d.comprobanteid = _this.comundata.comprobante._id;
        d.docRef = producto.dctoref ? _this.comundata.numDoc : "0";
        d.ccostos = producto.ccosto ? _this.encabezadoFactura.nccostos : "0";
        d.idCcostos = producto.ccosto ? _this.encabezadoFactura.ccostos : null;
        d.tipo = _this.comundata.comprobante.tipo === 1 ? 1 : 2;
        d.valor = _this.totalcontrapartida;
        d.year = functions.year(_this.comundata.periodo);
        d.mes = functions.mes(_this.comundata.periodo);
        d.esTotal = false;
        d.grupo = functions.grupo(producto.codigo);
        d.sgrupo = functions.sgrupo(producto.codigo);
        d.scuenta = functions.scuenta(producto.codigo);
        d.datosFactura = {
          fpago: _this.convertvalor(_this.encabezadoFactura.fpago),
          texto: _this.textoFactura
        };
        d.cumpleTodo = true;
      }
      if (estructura === "total") {
        d.idcuenta = producto._id;
        d.idnit = producto.tercero
          ? _this.encabezadoFactura.idnit
          : _this.empresa.nit0;
        d.descripcion = `Factura ${_this.comundata.numDoc} - ${_this.encabezadoFactura.nombreNit}`;
        d.fecha = new Date(
          functions.year(_this.comundata.periodo),
          functions.mes(_this.comundata.periodo) - 1,
          _this.comundata.dia
        );
        d.documento = _this.comundata.numDoc;
        d.comprobanteid = _this.comundata.comprobante._id;
        d.docRef = producto.dctoref ? _this.comundata.numDoc : "0";
        d.ccostos = producto.ccosto ? _this.encabezadoFactura.nccostos : "0";
        d.idCcostos = producto.ccosto ? _this.encabezadoFactura.ccostos : null;
        d.tipo = _this.comundata.comprobante.tipo === 1 ? 1 : 2;
        d.valor = _this.convertvalor(producto.valor);
        d.year = functions.year(_this.comundata.periodo);
        d.mes = functions.mes(_this.comundata.periodo);
        d.esTotal = false;
        d.grupo = functions.grupo(producto.codigo);
        d.sgrupo = functions.sgrupo(producto.codigo);
        d.scuenta = functions.scuenta(producto.codigo);
        d.datosFactura = {
          fpago: _this.convertvalor(_this.encabezadoFactura.fpago),
          texto: _this.textoFactura
        };
        d.cumpleTodo = true;
      }
      if (d.valor > 0) {
        _this.registros.push(d);
      }
    },
    createregproducto(_this, isSplice) {
      const d = {
        producto: null, // este es el id del producto para productos de punto de venta
        grupop: null, // este es el id del grupo del producto
        cantidad: 1, // numero de cantidades
        vlrUnitario: 0, // numero del valor unitario
        esTotal: false, // true o false para saber si es el total del documento
        descuento: 0, // descuento este dato solo lo tiene las cuentas de ventas de la factura
        orden: null,
        objetoProducto: null,
        // hasta aca es la estructura de la base de datos
        nombreproducto: null,
        nproducto: null,
        productodetalle: null,
        tProducto: true,
        tCantidad: true,
        tDescuento: true,
        tPreciounitario: true,
        cumpleProducto: true,
        cumpleCantidad: true,
        cumplePreciounitario: true,
        cumpleDescuento: true,
        cumpleTodo: false,
      };
      if (isSplice) {
        _this.productosfactura.splice(_this.productosfactura.length - 1, 0, d);
      } else {
        _this.productosfactura.push(d);
      }
    },
  },
  async created() {
    const usermongo = await apiServices.get(`/myuser`);
    if (
      usermongo.data.companys[this.empresa._id] &&
      usermongo.data.companys[this.empresa._id].preferences &&
      usermongo.data.companys[this.empresa._id].preferences.cuenta &&
      usermongo.data.companys[this.empresa._id].preferences.impresora &&
      usermongo.data.companys[this.empresa._id].preferences.incluircambio
    ) {
      console.log(
        "estoy en esta parte de la funcion para las preferences",
        usermongo.data.companys[this.empresa._id].preferences.impresora
      );
      this.encabezadoFactura.preferences.cuenta =
        usermongo.data.companys[this.empresa._id].preferences.cuenta;
      this.encabezadoFactura.preferences.impresora =
        usermongo.data.companys[this.empresa._id].preferences.impresora;
      this.encabezadoFactura.preferences.incluircambio =
        usermongo.data.companys[this.empresa._id].preferences.incluircambio;
      console.log(this.encabezadoFactura.preferences.impresora);
    } else {
      this.errorpreferences = true;
    }
    if (this.borrador) {
      this.registros = this.borrador.registros;
      this.encabezadoFactura = this.borrador.encabezado;
      this.contrapartida = this.borrador.contrapartida;
      this.productosfactura = this.borrador.productosfactura;
      this.totalesfactura = this.borrador.totalesfactura;
    } else {
      this.dataDefault();
      this.createregproducto(this, false);
    }
  },
  watch: {
    columna(nv, ov) {
      const temporal = {
        comprobante: this.comundata.comprobante,
        dia: this.comundata.dia,
        documento: this.comundata.numDoc,
        registros: this.registros,
        encabezado: this.encabezadoFactura,
        contrapartida: this.contrapartida,
        productosfactura: this.productosfactura,
        totalesfactura: this.totalesfactura,
      };
      localStorage.setItem("temporal", JSON.stringify(temporal));
      if (this.fila === -1) {
        // aqui para validar el encabezado
        this.validaencabezado(this.fila, ov, this);
        if (ov === this.selcolumnencabezado.columnnit) {
          // si la columna anterior es el nit
          if (this.encabezadoFactura.idnit === null) {
            this.$store.commit("launchModalnit", this.encabezadoFactura.nit);
            this.columna = this.selcolumnencabezado.columnnit;
          }
        }
      } else {
        if (ov === 1) {
          this.validaproducto();
        } else if (ov === 2) {
          this.validacantidad();
        } else if (ov === 3) {
          this.validapreciounitario();
        } else if (ov === 4) {
          this.validadescuento();
        }
        // aqui se valida los registros
      }
    },
    filatotal(nv, ov) {
      const temporal = {
        comprobante: this.comundata.comprobante,
        dia: this.comundata.dia,
        documento: this.comundata.numDoc,
        registros: this.registros,
        encabezado: this.encabezadoFactura,
        contrapartida: this.contrapartida,
        productosfactura: this.productosfactura,
        totalesfactura: this.totalesfactura,
      };
      localStorage.setItem("temporal", JSON.stringify(temporal));
    },
  },
  components: {
    yViewencabezado,
    yFormencabezado,
    yFormregistrofrapvta,
    yViewregistrofrapvta,
    yFormregistrototal,
    yModalcashback,
    yPrintfrapvta,
    yPrintfrapvtastrip,
    yPrintfrapvtastrip80,
  },
};
</script>


<style lang="scss" scoped>
.numero {
  font-size: 14px;
  padding-top: 3px;
  padding-bottom: 3px;
  width: 27px;
  border-radius: 20px;
}
.media1 {
  padding-top: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid whitesmoke;
}
.is-total {
  border-bottom: 4px solid whitesmoke;
  border-top: 3px solid whitesmoke;
  padding-top: 10px;
  padding-bottom: 10px;
}
.divtotal {
  width: 100%;
  margin-top: 3px;
  height: 38px;
}
.texttotal {
  background-color: whitesmoke;
  padding: 3px 0px 3px 12px;
  width: 50%;
  border-left: 4px solid whitesmoke;
  border-bottom: 4px solid whitesmoke;
  border-top: 4px solid whitesmoke;
  color: #7a7a7a;
  float: left;
  border-radius: 4px 0px 0px 4px;
}
.numerototal {
  border: 4px solid whitesmoke;
  padding: 3px 12px 3px 0px;
  width: 50%;
  color: #7a7a7a;
  float: left;
  border-radius: 0px 4px 4px 0px;
}
.totales {
  justify-content: left !important;
}
.inputtotal {
  text-align: right !important;
}
.field:not(:last-child) {
  margin-bottom: 0.2rem;
}
.totalselected {
  color: #00d1b2;
  font-weight: bold;
}
.datospruducto {
  table,
  td,
  th {
    font-size: 14px;
    // border: 1px solid #eeeeee !important;
    padding-left: 3px !important;
    padding-right: 3px !important;
    color: #8b8b8b !important;
  }

  tfoot {
    border: 0px !important;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/registrar/Estructurafrapventa.vue